import { useTranslation } from 'react-i18next';
import { T } from '../../components/text/TextEdit';
import { brandMark } from '../../lib/brand';

// The two-column sign-in shell, ported from docs/ui/novamund-proto.html, which took it from
// shadcn-admin /sign-in-2. The mock's ledger makes it authoritative for these screens: they are a
// deliberate redesign, not a replica of what the live pages looked like.
//
// These pages render WITHOUT AppShell - no sidebar, no header. Nobody is signed in yet, so there
// is nothing for a sidebar to navigate.
//
// Zero new locale keys, which the ledger requires: app.name, dashboard.languageLabel, language.*,
// and whatever the page passes in.
//
// The visual panel is a PLACEHOLDER and carries no copy. The mock draws filler text inside it;
// filler is not a string, and inventing a key for it would break the zero-new-keys rule. Below lg
// the panel is not drawn at all rather than squeezed into a strip.
export default function AuthShell({ children, testId }) {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-screen bg-background text-foreground lg:grid-cols-2" data-testid={testId}>
      <div className="hidden items-center justify-center bg-muted p-10 lg:flex" data-testid="auth-visual">
        <div className="h-[min(58vh,400px)] w-full max-w-[520px] rounded-xl border-2 border-dashed border-border bg-card" />
      </div>

      <div className="flex flex-col px-7 py-6">
        {/* The language switcher is gone (Persian lock, Ali 2026-08-04) — the UI is fa-only. */}
        <div className="flex flex-1 items-center justify-center py-8">
          <div className="w-full max-w-[360px]">
            <div className="mb-9 flex items-center justify-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary font-heading text-sm font-extrabold text-primary-foreground">
                {brandMark(t('app.name'))}
              </span>
              <span className="font-heading text-[17px] font-bold"><T k="app.name" /></span>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}